import React, {Component} from 'react';
import { Link } from 'react-router';
import Slider from '../components/Slider';

import '../css/navbar.css';
import '../css/art.css';

class News extends Component
{
  constructor(props) {
    super(props)
    this.state = {
      data: [],
    }
  }

  componentWillMount() {
    var arr = [];
    var list = [];
    var chunk_size = 4;
    var thisState = this;
    fetch('/api/getnews', {
        method: 'GET',
      }).then((resp) => resp.json())
      .then(function(data) {
        arr = Object.keys(data.news).map(function(obj) {
          return data.news[obj];
        });
        var newsCount = Object.keys(data.news).length;
        if (newsCount % 4 !== 0) {
          if (newsCount <= 4) {
            var val = 4 - newsCount;
            for (var i = 0; i < val; i++) {
              arr.push({
                  "url": "",
                  "news_content":"",
                  "content": "",
                  "thumb_url": "",
              })
            }
          } else {
            val = 4 - Math.floor(newsCount%4);
            for (i = 0; i < val; i++) {
              arr.push({
                  "url": "",
                  "news_headline":"",
                  "news_content": "",
                  "thumb_url": "",
              })
            }
          }
        }
        for (i=0; i<arr.length; i+=4) {
            list.push(
              <div key={i}>
                  <Table
                    index={i}
                    array={arr.slice(i,i+chunk_size)}
                    /></div>
                );
          }
        thisState.setState({ data: list })
      });
  }

    render() {
        return (
          <div className="main" style={{ overflow: "scroll"}}>
              <div className="outer">
                  <div className="middle">
                      <div className="inner">
                          <div className="slider">
                            <Slider showNav={ this.state.data.length > 4 ? true: false }>
                                { this.state.data }
                            </Slider>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        );
    }
}
export default News;

class Table extends Component {
    render() {
        return (
          <div>
              <table>
                  <tbody>
                          <tr>
                            {
                              this.props.array[0].news_status === '0' ? <ColValid data={this.props.array[0]} /> : <ColDisabled data={this.props.array[0]}  />
                            }
                            {
                              this.props.array[1].news_status === '0' ? <ColValid data={this.props.array[1]} /> : <ColDisabled data={this.props.array[1]}  />
                            }
                          </tr>
                          <tr>
                            {
                              this.props.array[2].news_status === '0' ? <ColValid data={this.props.array[2]} /> : <ColDisabled data={this.props.array[2]}  />
                            }
                            {
                              this.props.array[3].news_status === '0' ? <ColValid data={this.props.array[3]} /> : <ColDisabled data={this.props.array[3]}  />
                            }
                          </tr>
                  </tbody>
              </table>
          </div>
        )
    }
};

function ColValid(props) {
    return (
      <td>
        <Link to={'/news/' + props.data.news_url} >
            <figure className="art image-container">
                <figcaption>
                    <div className="news-content">
                        <hd>
                            {props.data.news_headline}
                        </hd>
                    </div>
                </figcaption>
            </figure>
        </Link>
      </td>
    );
  }
  class ColDisabled extends Component {
    constructor(props) {
      super(props);
      this.state = {
        mouseOver: false,
      }
      this.handleOnMouseOver = this.handleOnMouseOver.bind(this);
      this.handleOnMouseOut = this.handleOnMouseOut.bind(this);
    }
    handleOnMouseOver() {
      this.setState({mouseOver:true})
    }
    handleOnMouseOut() {
      this.setState({mouseOver:false})
    }
    render() {
      var name = this.props.data.news_headline ? this.props.data.news_headline : "...";
      return (
        <td>
            <figure
              className="image-container-disabled"
              style={{
                backgroundSize: "cover",
                opacity:'.6',
                background: "rgb(242, 242, 242)"
              }}
                onMouseOver={this.handleOnMouseOver}
                onMouseLeave={this.handleOnMouseOut}
                >
                <figcaption>
                    <div>
                      {
                        !this.state.mouseOver ? (<p>{name}</p>) :
                        (<p>Coming soon</p>)
                      }
                    </div>
                </figcaption>
            </figure>
        </td>
      );

    }
  }



// WEBPACK FOOTER //
// ./src/pages/News.js